import { useCallback, useState } from 'react';

export const useAuthForm = ({ login, logout, t }) => {
  const [formState, setFormState] = useState({ username: '', password: '' });
  const [errorMessage, setErrorMessage] = useState('');
  const [noticeMessage, setNoticeMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = useCallback((event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      setErrorMessage('');
      setNoticeMessage('');
      setIsSubmitting(true);

      try {
        await login({
          username: formState.username.trim(),
          password: formState.password,
        });
        setFormState({ username: '', password: '' });
        setNoticeMessage(t('loginSuccess'));
      } catch (error) {
        if (error?.status === 401) {
          setErrorMessage(t('loginInvalid'));
        } else if (error?.status === 400) {
          setErrorMessage(t('loginMissing'));
        } else {
          setErrorMessage(t('loginFailed'));
        }
      } finally {
        setIsSubmitting(false);
      }
    },
    [formState.password, formState.username, login, t],
  );

  const handleLogout = useCallback(async () => {
    setErrorMessage('');
    setNoticeMessage('');

    try {
      await logout();
    } finally {
      setNoticeMessage(t('logoutSuccess'));
    }
  }, [logout, t]);

  return {
    formState,
    errorMessage,
    noticeMessage,
    isSubmitting,
    handleInputChange,
    handleSubmit,
    handleLogout,
  };
};
